export default __webpack_public_path__ + "0e79765ff2e97354cfa125ad338f74c0.svg";